"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var client_exports = {};
__export(client_exports, {
  ClerkApp: () => import_ClerkApp.ClerkApp,
  OrganizationProfile: () => import_uiComponents.OrganizationProfile,
  SignIn: () => import_uiComponents.SignIn,
  SignUp: () => import_uiComponents.SignUp,
  UserProfile: () => import_uiComponents.UserProfile,
  WithClerkState: () => import_types.WithClerkState
});
module.exports = __toCommonJS(client_exports);
__reExport(client_exports, require("./RemixClerkProvider"), module.exports);
var import_ClerkApp = require("./ClerkApp");
var import_types = require("./types");
var import_uiComponents = require("./uiComponents");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ClerkApp,
  OrganizationProfile,
  SignIn,
  SignUp,
  UserProfile,
  WithClerkState,
  ...require("./RemixClerkProvider")
});
//# sourceMappingURL=index.js.map